<!-- Desktop minimized icon -->
<button
  class="chat-float-icon"
  *ngIf="isClosed"
  (click)="openChatBox()"
  aria-label="Open chat support">
  <i class="bi bi-chat-dots"></i>
</button>

<!-- Full chat box -->
<div class="chat-box" *ngIf="!isClosed">
  <button
    class="chat-close"
    (click)="closeChatBox()"
    aria-label="Close chat support">
    <i class="bi bi-x"></i>
  </button>

  <div class="chat-header">
    <div class="chat-icon">
      <i class="bi bi-chat-dots"></i>
    </div>

    <div class="chat-title">
      <strong>Need help?</strong>
      <span>{{ supportSubtitle }}</span>
    </div>
  </div>

  <button class="chat-button" (click)="openWhatsApp()">
    <div class="whatsapp-icon">
      <i class="bi bi-whatsapp"></i>
    </div>

    <span>{{ supportLabel }}</span>

    <i class="bi bi-chevron-right arrow-icon"></i>
  </button>
</div>